const $ = window.jQuery;
const $window = window.$window || $(window);

const partnerFilter = {
  init() {
    var $module = $(".partners-section");
    if (!$module.length) return;

    $module.each((index, element) => {
      this.each(element);
    });
  },

  each(element) {
    console.log("RDY");
    //

    // Select all div with the class
    // attribute "division"
    $(".partner-filter").click(function() {
      if ($(this).hasClass("all")) {
        $(".single-partner")
          .removeClass("active")
          .show();
      } else {
        var partner = $(this).data("partner");
        $(this).addClass("active");
        $(".single-partner").hide();
        $(".single-partner." + partner).show();
      }
    });
    $(".partner-filter button").click(function() {
      $(".partner-filter button").removeClass(
        "text-white bg-brand-black text-brand-black bg-transparent hover:bg-brand-black/10"
      );

      $(this).addClass("text-white bg-brand-black");
    });
  },
};

export default partnerFilter;
